import React, {useState} from 'react';
import {Button, Stack} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {finalize} from 'rxjs';
import {useSnackbar} from 'notistack';
import {useObservable} from '@ngneat/react-rxjs';

import {GlobalStatus} from '@store/common/globalStatus.enum';
import {suppliersUnitsQuery, suppliersUnitsService} from '@store/suppliers/units';

import {Download, GroupAction} from '@icons/index';

import TabsComponent from '@components/tabs/Tabs.component';
import SuppliersUnitsTable from '@screens/admin/suppliers/units/SuppliersUnits.table';

const SuppliersUnitsTab = () => {
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();

  const [CSVLoading, setCSVLoading] = useState(false);

  const [filterStatus] = useObservable(suppliersUnitsQuery.status$);
  const [selectedSuppliersUnits] = useObservable(suppliersUnitsQuery.selectedSuppliersUnits$);

  const handleExportCSV = () => {
    setCSVLoading(true);
    suppliersUnitsService.getSuppliersUnitsCSV()
      .pipe(finalize(() => setCSVLoading(false)))
      .subscribe({
        error: (err) => enqueueSnackbar(err.text, err.options),
      });
  };

  return (
    <Stack flex={1} width="100%" spacing={2} mt="-35px">
      <Stack alignSelf="flex-end" direction="row" alignItems="center" spacing={2}>
        <Button
          variant="outlined" color="primary"
          disabled={!selectedSuppliersUnits.length}
          startIcon={<GroupAction/>}>
          {t('global.groupedAction')}
        </Button>
        <Button
          variant="outlined" color="primary"
          disabled={CSVLoading}
          onClick={handleExportCSV}
          startIcon={<Download/>}>
          {t('global.exportCSV')}
        </Button>
      </Stack>
      <Stack flex={1} spacing={3}>
        <TabsComponent
          ariaLabel="secondary"
          handleChange={(value) => {
            suppliersUnitsService.setStatus(GlobalStatus.tabs[value]);
          }}
          value={GlobalStatus.tabs.indexOf(filterStatus ?? undefined)}
          tabs={[t('routes.all'), t('routes.archived')]}/>
        <Stack flex={1}>
          <SuppliersUnitsTable/>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default SuppliersUnitsTab;
